import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeUrlModule } from 'src/app/utils/pipes/safe-url.module';

@Component({
  selector: 'app-iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SafeUrlModule
  ]
})
export class IframeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<IframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string }
  ) {}
}